/**
 * Check if two arrays are equal
 *
 * @param {unknown[]} arr1
 * @param {unknown[]} arr2
 * @return {*}  {boolean}
 */
const isArrayEqual = (arr1: unknown[], arr2: unknown[]): boolean => {
    return isArrayEqualBy(arr1, arr2);
};

type Iteratee<T, Value = string | number> = (item: T) => Value;

/**
 * Check if two arrays are equal by an iteratee \
 * If iteratee function is not provided, it will default to comparing the items
 * directly
 */
const isArrayEqualBy = <T>(
    arr1: T[],
    arr2: T[],
    iteratee: Iteratee<T, unknown> = item => {
        return item;
        // if (typeof item === "string") return item
        // if (typeof item === "number") return item
        // throw new
    },
): boolean => {
    if (Object.is(arr1, arr2)) return true;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (!Object.is(iteratee(arr1[i]), iteratee(arr2[i]))) return false;
    }
    return true;
};

export { isArrayEqual, isArrayEqualBy };
